import { useState } from 'react';
import { useInView } from '../hooks/useInView';
import { PROJECTS } from '../data';

const FILTERS = ['All', 'Freelance', 'Excelsoft'];

function ProjectCard({ project: p, index }) {
  const [ref, inView] = useInView(0.08);
  return (
    <div ref={ref}
         className="bg-surf border border-bord rounded-2xl p-5 border-t-[3px] cursor-default
                    transition-all duration-500 hover:bg-surf2 group"
         style={{
           borderTopColor: p.color,
           opacity: inView ? 1 : 0,
           transform: inView ? 'none' : 'translateY(22px)',
           transitionDelay: `${index * 0.07}s`,
         }}
         onMouseEnter={e => { e.currentTarget.style.borderColor = p.color + '55'; e.currentTarget.style.boxShadow = `0 16px 40px rgba(0,0,0,.4),0 0 26px ${p.color}18`; }}
         onMouseLeave={e => { e.currentTarget.style.borderColor = '#1e2d47'; e.currentTarget.style.boxShadow = 'none'; }}>
      {/* Header */}
      <div className="flex justify-between items-start mb-3">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center text-base border"
               style={{ background: p.color + '20', borderColor: p.color + '44' }}>
            {p.icon}
          </div>
          <div>
            <div className="font-bold text-sm text-tx">{p.name}</div>
            <span className="font-mono text-[9px] rounded px-1.5 py-0.5 mt-0.5 inline-block"
                  style={{ color: p.color, background: p.color + '18', border: `1px solid ${p.color}33` }}>
              {p.tag}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-1 flex-shrink-0">
          <div className="w-1.5 h-1.5 rounded-full" style={{ background: p.status === 'Active' ? '#10B981' : '#64748B', animation: p.status === 'Active' ? 'pulseDot 2s infinite' : 'none' }} />
          <span className="font-mono text-[9px]" style={{ color: p.status === 'Active' ? '#10B981' : '#64748B' }}>{p.status}</span>
        </div>
      </div>
      <p className="text-xs text-tx2 leading-relaxed mb-3">{p.desc}</p>
      <div className="flex flex-col gap-1 mb-3">
        {p.highlights.map((h, i) => (
          <div key={i} className="flex items-start gap-1.5">
            <span className="text-[10px] mt-0.5 flex-shrink-0" style={{ color: p.color }}>▸</span>
            <span className="text-[11px] text-tx3 leading-snug">{h}</span>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-1.5 pt-3 border-t border-bord">
        {p.tech.map(t => (
          <span key={t} className="font-mono text-[9px] text-tx3 bg-surf border border-bord rounded px-1.5 py-0.5">{t}</span>
        ))}
      </div>
    </div>
  );
}

export default function Projects() {
  const [filter, setFilter] = useState('All');
  const filtered = filter === 'All' ? PROJECTS : PROJECTS.filter(p => p.category === filter);

  return (
    <section id="projects" className="relative z-10 py-24 px-5 sm:px-8"
             style={{ background: 'linear-gradient(180deg,#080c14 0%,#0d1220 100%)' }}>
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="section-tag bg-pur/10 border border-pur/25 text-pur">{`// PROJECTS`}</span>
          <h2 className="font-display font-extrabold tracking-tight mb-8" style={{ fontSize: 'clamp(28px,4vw,46px)' }}>
            Things I've <span className="text-aws">built & shipped</span>
          </h2>
          <div className="flex gap-2 justify-center flex-wrap">
            {FILTERS.map(f => (
              <button key={f} onClick={() => setFilter(f)}
                      className={`font-mono text-[10px] sm:text-xs px-4 py-1.5 rounded-lg border cursor-pointer transition-all duration-150
                                 ${filter === f ? 'text-aws bg-aws/[.13] border-aws/40' : 'text-tx3 bg-transparent border-bord hover:text-tx'}`}>
                {f}
                {f !== 'All' && <span className="ml-1 opacity-60">({PROJECTS.filter(p=>p.category===f).length})</span>}
              </button>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-5">
          {filtered.map((p, i) => <ProjectCard key={p.name} project={p} index={i} />)}
        </div>
      </div>
    </section>
  );
}
